// Marker SVGs are built here, not loaded as files, so they can follow the section theme.
// Default colors are the original Swegon green markers.
const DEFAULT_COLOR = '#39B812';
const DEFAULT_SELECTED_COLOR = '#7FC600';
// Themes have no lighter shade, so the lighter markers use the theme color with the cluster's opacity
const THEME_LIGHT_OPACITY = 0.7;

const PIN_PATH = 'M35,16.6304348 C35,25.8193043 17.5,51 17.5,51 C17.5,51 0,25.8193043 0,16.6304348 C0,7.446 7.833,0 17.5,0 C27.1646667,0 35,7.446 35,16.6304348 Z';

const pin = (color, opacity = 1) => `
<svg width="37" height="52" viewBox="0 0 37 52" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
        <path d="${PIN_PATH}" fill="${color}" stroke="${color}" opacity="${opacity}" stroke-linecap="round" stroke-linejoin="round"/>
        <circle fill="#FFFFFF" cx="17.5" cy="16.5" r="8.5"/>
    </g>
</svg>`;

const search = (color) => `
<svg width="47" height="47" viewBox="0 0 47 47" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd" stroke-linejoin="round">
        <circle stroke="${color}" fill="${color}" stroke-linecap="round" cx="22.5" cy="22.5" r="22.5"/>
        <g transform="translate(13 12)" stroke="#FFFFFF">
            <path d="M14,7 C14,10.86575 10.86575,14 7,14 C3.13425,14 0,10.86575 0,7 C0,3.13425 3.13425,0 7,0 C10.86575,0 14,3.13425 14,7 Z"/>
            <path d="M12,12 L21,21" stroke-linecap="round"/>
        </g>
    </g>
</svg>`;

const cluster = (color) => `
<svg width="62" height="62" viewBox="0 0 62 62" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
        <circle stroke="${color}" fill="${color}" opacity="0.7" stroke-linecap="round" stroke-linejoin="round" cx="30" cy="30" r="30"/>
        <circle fill="#FFFFFF" cx="30" cy="30" r="18"/>
    </g>
</svg>`;

// Parentheses are encoded too, so the url is also safe unquoted in css url()
const toDataUrl = (svg) => `data:image/svg+xml,${
    encodeURIComponent(svg.trim()).replace(/\(/g, '%28').replace(/\)/g, '%29')
}`;

// Theme color is set as a custom property on .google-map__map in google-map.scss
const getThemeColor = (mapElement) => (
    mapElement
        ? window.getComputedStyle(mapElement).getPropertyValue('--google-map-marker-color').trim()
        : ''
);

const getMarkerIcons = (mapElement) => {
    const themeColor = getThemeColor(mapElement);
    const color = themeColor || DEFAULT_COLOR;

    return {
        pin: toDataUrl(pin(color)),
        pinSelected: toDataUrl(themeColor
            ? pin(themeColor, THEME_LIGHT_OPACITY)
            : pin(DEFAULT_SELECTED_COLOR)),
        search: toDataUrl(search(color)),
        cluster: toDataUrl(cluster(color))
    };
};

export default getMarkerIcons;
